// extracted by mini-css-extract-plugin
module.exports = {"button":"style_button__2NB1i","buttonBlack":"style_buttonBlack__26JJ7"};